// extracted by mini-css-extract-plugin
module.exports = {"overlay":"CompanyModal_overlay___OsOm","inputContainer":"CompanyModal_inputContainer__27yV-","text":"CompanyModal_text__uHGvf","label":"CompanyModal_label__1TFD0"};